'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Combobox", {
    enumerable: true,
    get: function() {
        return Combobox;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCombobox = require("./useCombobox");
const _renderCombobox = require("./renderCombobox");
const _useComboboxStylesstyles = require("./useComboboxStyles.styles");
const _useComboboxContextValues = require("../../contexts/useComboboxContextValues");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Combobox = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCombobox.useCombobox_unstable)(props, ref);
    const contextValues = (0, _useComboboxContextValues.useComboboxContextValues)(state);
    (0, _useComboboxStylesstyles.useComboboxStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useComboboxStyles_unstable')(state);
    return (0, _renderCombobox.renderCombobox_unstable)(state, contextValues);
});
Combobox.displayName = 'Combobox';
